import { UserAgentHeaders } from './types';

export const getUserAgentHeaders = async (): Promise<UserAgentHeaders> => {
  // browsers don't allow to set User-Agent on web
  return {};
};
